/** The queue at tablet and desktop: a summary line and both headed sections. */
import type { WorkshopShell } from '../../dashboards/workshopDetailUrlFor';
import { queueSummary } from '../reviewQueueModel';
import { ReviewQueueSection } from '../ReviewQueueSection';
import type { ReviewQueueResponse } from '../reviewTypes';

export default function ReviewQueueDesktopBody({
  data,
  showResolved,
  shell,
}: {
  data: ReviewQueueResponse;
  showResolved: boolean;
  shell: WorkshopShell;
}) {
  return (
    <>
      <p style={{ margin: 0, fontSize: 12.5, color: 'var(--nb-muted)', maxWidth: 900 }}>
        {queueSummary(data.openCount)}
      </p>
      <ReviewQueueSection
        kind="booking"
        rows={data.bookings}
        showResolved={showResolved}
        shell={shell}
      />
      <ReviewQueueSection
        kind="checkout"
        rows={data.checkouts}
        showResolved={showResolved}
        shell={shell}
      />
    </>
  );
}
